<template>
	<div>
		<div class="card">
			<div
				class="card-header bg-dark d-flex justify-content-between align-items-center rounded"
			>
				<h3 class="mb-0 text-white">กราฟรายการถอน</h3>

				<div class="d-flex">
					<div class="mx-1">
						<base-input label="วันที่" labelClasses="text-white">
							<flat-picker class="form-control datepicker" v-model="startDate" />
						</base-input>
					</div>
					<div class="mx-1">
						<base-input label="ถึง" labelClasses="text-white">
							<flat-picker class="form-control datepicker" v-model="endDate" />
						</base-input>
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-if="data">
			<div class="col-md-6">
				<withdraw-hour-graph :data="data" />
			</div>
		</div>
	</div>
</template>

<script>
import flatPicker from 'vue-flatpickr-component'
import WithdrawHourGraph from '../backend-components/Graph/WithdrawHourGraph'

import moment from 'moment'
import SummaryService from '../services/summary.service'

export default {
	components: { flatPicker, WithdrawHourGraph },
	data() {
		return {
			data: null,

			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
		}
	},
	methods: {
		fetchData() {
			SummaryService.getWithdrawSummary({
				start: this.startDate,
				end: this.endDate,
			})
				.then((res) => {
					this.data = res
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
		},
	},
	created() {
		this.fetchData()
	},
	watch: {
		startDate() {
			this.fetchData()
		},
		endDate() {
			this.fetchData()
		},
	},
}
</script>
